/* Keep the Liquid stock result current. No client-side inventory estimates. */
(function () {
  'use strict';
  if (window.minkStockBadges) return;
  window.minkStockBadges = true;
  var busy = false;
  var lastRequest = 0;
  function slots() { return Array.prototype.slice.call(document.querySelectorAll('[data-stock-badge]')); }
  function hideUnknown(nodes) { nodes.forEach(function (node) { node.replaceChildren(); }); }
  async function refresh() {
    var nodes = slots();
    if (!nodes.length || document.hidden || busy || Date.now() - lastRequest < 15000) return;
    var sections = Array.from(new Set(nodes.map(function (node) { return node.dataset.stockBadgeSection; }).filter(Boolean))).slice(0, 5);
    if (!sections.length) return;
    lastRequest = Date.now();
    busy = true;
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 8000);
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('sections', sections.join(','));
      var response = await fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Stock render unavailable');
      var data = await response.json();
      var parsed = {};
      sections.forEach(function (id) {
        parsed[id] = typeof data[id] === 'string' ? new DOMParser().parseFromString(data[id], 'text/html') : null;
      });
      nodes.forEach(function (node) {
        var fragment = parsed[node.dataset.stockBadgeSection];
        var replacement = fragment && Array.from(fragment.querySelectorAll('[data-stock-badge]')).find(function (fresh) { return fresh.dataset.stockBadgeKey === node.dataset.stockBadgeKey; });
        if (replacement) node.replaceChildren.apply(node, Array.from(replacement.childNodes).map(function (child) { return document.importNode(child, true); }));
        else node.replaceChildren();
      });
    } catch (error) {
      hideUnknown(nodes);
    } finally {
      window.clearTimeout(timeout);
      busy = false;
    }
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', refresh);
  ['cart:updated', 'cart:change'].forEach(function (event) { document.addEventListener(event, refresh); });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.tagName === 'FORM' && /\/cart(?:\/|$)/.test(new URL(form.action, window.location.href).pathname)) window.setTimeout(refresh, 1200);
  }, true);
  window.setInterval(refresh, 60000);
})();
